import React, { useState, useRef, useEffect, memo, useImperativeHandle, forwardRef } from 'react';
import { Input } from 'antd';

const DebouncedInput = memo(forwardRef(function DebouncedInput({
                                                      disabled,
                                                      placeholder,
                                                      setLabelId,
                                                      maxLength,
                                                      onFinished,    // called once the user “pauses” typing or presses Enter
                                                      pause = 500    // ms to wait after last keystroke
                                                    }, ref) {

  const [value, setValue] = useState('');
  const timer = useRef();
  const inputRef = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  useImperativeHandle(ref, () => ({
    setLabelIdFromParent: (newValue) => {
      setValue(newValue);
      inputRef.current.focus();
    }
  }));

  useEffect(() => {
    if (value.length === 8) {
      setLabelId(value); // Call setLabelId immediately when value has 8 characters
    }
  }, [value, setLabelId]);

  // 3) On every keystroke, update local state + reset debounce
  const handleChange = e => {
    const v = e.target.value;
    setValue(v); // Update local state immediately
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (v.length !== 8) {  // Avoid unnecessary updates when length is 8
        setLabelId(v); // Pass the value to the parent after debounce delay
      }
    }, pause);
  };

  // 4) On Enter, flush immediately and then clear the field
  const handleEnter = () => {
    clearTimeout(timer.current);
    onFinished(value);
    setValue('');
    inputRef.current.focus();
  };

  return (
    <Input
      ref={inputRef}
      disabled={disabled}
      placeholder={placeholder}
      value={value}               // controlled!
      onChange={handleChange}
      onPressEnter={handleEnter}
      maxLength={maxLength}
      style={{ marginRight: 10, minWidth: 150, maxWidth: 150 }}
    />
  );
}));

export default DebouncedInput;
